import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import MaterialDialog from '@material-ui/core/Dialog';
import '../styles/Dialog.scss';

const Dialog = (props) => {
    let transitionProps = {};
    if (props.onExited) {
        transitionProps.onExited = props.onExited;
    }

    return (
        <MaterialDialog id={props.id} className="dialog" open={props.open} onClose={props.onClose}
                        TransitionProps={transitionProps}
        >
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>{props.children}</DialogContent>
            <DialogActions/>
        </MaterialDialog>
    );
};

Dialog.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onExited: PropTypes.func,
};

export default Dialog;
